// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EntriesReviewBody { 
    /**
     * The status
     */
    status: EntriesReviewBody.StatusEnum;
    /**
     * The comment if the entry is rejected
     */
    comment?: string;
}
export namespace EntriesReviewBody {
    export type StatusEnum = 'reviewed' | 'approved' | 'rejected';
    export const StatusEnum = {
        reviewed: 'reviewed' as StatusEnum,
        approved: 'approved' as StatusEnum,
        rejected: 'rejected' as StatusEnum
    };
}


